import { render, staticRenderFns } from "./ParcelaTab2ViaContent.vue?vue&type=template&id=f4477154&scoped=true"
import script from "./ParcelaTab2ViaContent.vue?vue&type=script&lang=js"
export * from "./ParcelaTab2ViaContent.vue?vue&type=script&lang=js"
import style0 from "./ParcelaTab2ViaContent.vue?vue&type=style&index=0&id=f4477154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4477154",
  null
  
)

export default component.exports